var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09998 0.25C4.70442 0.25 2.07724 3.22603 2.49841 6.59536L2.57776 7.23021C2.69388 8.15916 2.35455 9.08706 1.66654 9.72195C0.240863 11.0375 -0.155232 13.1315 0.691418 14.8769L0.794769 15.09C1.54092 16.6282 3.05598 17.6356 4.74728 17.7409L4.93556 18.0636C5.94835 19.7998 7.52636 20.75 9.18339 20.75C10.8404 20.75 12.4184 19.7998 13.4312 18.0636L13.6225 17.7358C15.0431 17.6235 16.3385 16.8513 17.1111 15.6373C18.2932 13.7799 17.9801 11.3432 16.3668 9.84496L16.3229 9.8042C15.9565 9.46395 15.6824 9.04657 15.5145 8.59023C15.0699 8.85069 14.5524 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C14.2417 3 14.4768 3.02859 14.702 3.08258C13.7317 1.40121 11.9159 0.25 9.80289 0.25H8.09998ZM9.18339 19.25C8.26226 19.25 7.27948 18.7877 6.52013 17.75H11.8467C11.0873 18.7877 10.1045 19.25 9.18339 19.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1832 6C16.1832 7.10457 15.2878 8 14.1832 8C13.0787 8 12.1832 7.10457 12.1832 6C12.1832 4.89543 13.0787 4 14.1832 4C15.2878 4 16.1832 4.89543 16.1832 6Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.58caa12b1c2a58fbc90200502cc66368.svg";
export { ForwardRef as ReactComponent };